import React from 'react'
import { useNavigate } from 'react-router-dom'

const MISSION_NAME = 'Glenwood Op 9/3/26'

const TEAMS = [
  {
    id: 1,
    label: 'Team 1 — Wake / Meck',
    badges: ['/wake abc patch.png', '/meck abc.jpg'],
  },
  {
    id: 2,
    label: 'Team 2 — Wake / Meck',
    badges: ['/wake abc patch.png', '/meck abc.jpg'],
  },
  {
    id: 3,
    label: 'Team 3 — Raleigh PD',
    badges: ['/raleigh pd badge.jpeg'],
  },
  {
    id: 4,
    label: 'Team 4 — WCSO',
    badges: ['/Wake Sheriff Badge.jpeg'],
  },
]

export default function MissionLanding() {
  const navigate = useNavigate()

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0f1f3d',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '2rem 1.25rem',
      fontFamily: "'Inter', system-ui, sans-serif",
    }}>
      <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
        <div style={{ fontSize: 12, fontWeight: 600, letterSpacing: '0.12em', color: '#8aadd4', textTransform: 'uppercase', marginBottom: '0.5rem' }}>
          ABCAxis · Mission Tally
        </div>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: '#ffffff', margin: 0, letterSpacing: '-0.02em' }}>
          {MISSION_NAME}
        </h1>
        <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.45)', marginTop: '0.5rem' }}>
          Select your team to begin recording charges
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%', maxWidth: 420 }}>
        {TEAMS.map(team => (
          <button
            key={team.id}
            onClick={() => navigate(`/mission/${team.id}`)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              background: 'rgba(61,100,148,0.2)',
              border: '1px solid rgba(61,100,148,0.4)',
              borderRadius: 12,
              padding: '1.25rem 1.5rem',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'background 0.15s, border-color 0.15s',
              width: '100%',
            }}
            onTouchStart={e => e.currentTarget.style.background = 'rgba(61,100,148,0.35)'}
            onTouchEnd={e => e.currentTarget.style.background = 'rgba(61,100,148,0.2)'}
          >
            <div style={{ display: 'flex', gap: '0.5rem', flexShrink: 0 }}>
              {team.badges.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt=""
                  style={{ width: 52, height: 52, objectFit: 'contain', borderRadius: 4 }}
                />
              ))}
            </div>
            <div>
              <div style={{ fontSize: 16, fontWeight: 700, color: '#ffffff' }}>{team.label}</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginTop: 2 }}>Tap to open tally</div>
            </div>
            <div style={{ marginLeft: 'auto', color: 'rgba(255,255,255,0.3)', fontSize: 20 }}>›</div>
          </button>
        ))}
      </div>
    </div>
  )
}
